/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeatureRequestDto } from '../../models/feature-request-dto';
import { FeatureRequestFullResponseDto } from '../../models/feature-request-full-response-dto';

export interface SubmitFeatureRequest$Params {
      body: FeatureRequestDto
}

export function submitFeatureRequest(http: HttpClient, rootUrl: string, params: SubmitFeatureRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureRequestFullResponseDto>> {
  const rb = new RequestBuilder(rootUrl, submitFeatureRequest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureRequestFullResponseDto>;
    })
  );
}

submitFeatureRequest.PATH = '/api/v1/feature';
